const SocialTItle: React.FC = (props) => (
  <div className="social-title">
    <div className="social-title__box">
      <div className="social-title__rotation">
        <svg
          className="social-title__svg"
          viewBox="0 0 1094 1055"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0H1094V1055H0V0Z"
            stroke="transparent"
            fill="transparent"
          />
          <path
            d="M1013 527.5C1013 774.095 804.365 974 547 974C289.635 974 81 774.095 81 527.5C81 280.905 289.635 81 547 81C804.365 81 1013 280.905 1013 527.5Z"
            stroke="transparent"
            fill="transparent"
            id="circle"
          />


          <text className="text">
            <textPath xlinkHref="#circle" startOffset="68%">
              JOIN OUR COMMUNITY
            </textPath>
          </text>
          <linearGradient
            id="join-our-community-title"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
          >
            {Array.from({ length: 24 })
              .map((_, id, arr) => (
                <stop
                  key={id}
                  stopColor={id % 2 === 0 ? '#dfffc4' : '#fff'}
                  offset={(id + 1) / arr.length}
                />
              ))}
          </linearGradient>
        </svg>
        
      </div>
    </div>
  </div>
);

export default SocialTItle;
